import { Component, Input } from '@angular/core';
import { BtHSeparatorModel, BT_SEPARATOR_STYLE } from './bt-hseparator.model';

@Component({
    selector: 'bt-hseparator',
    templateUrl: './bt-hseparator.component.html',
    styleUrls: ['./bt-hseparator.component.scss']
})
export class BtHSeparatorComponent {
    @Input() model: BtHSeparatorModel;
    @Input() value: any;
    BT_SEPARATOR_STYLE = BT_SEPARATOR_STYLE;
}